import { Component, Input, OnChanges, SimpleChange } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-password-strength',
    templateUrl: './password-strength.component.html',
    styleUrls: ['./password-strength.component.scss'],
    standalone: false
})
export class PasswordStrengthComponent implements OnChanges {
  @Input() text: any;
  errors: any = [
    {
      message: '8-20 characters',
      valid: false,
      regex: new RegExp('(^.{8,20}$)')
    },
    {
      message: 'A lowercase letter (a-z)',
      valid: false,
      regex: new RegExp('(?=.*[a-z])')
    },
    {
      message: 'A capital letter (A-Z)',
      valid: false,
      regex: new RegExp('(?=.*[A-Z])')
    },
    {
      message: 'A symbol (e.g. !"#$%&)',
      valid: false,
      regex: {
        test: function(val){
          const set1 = new Set('£€!"#$%&\'()*+,-./:;<=>?@[\]^_`{|}~');
          var set2 = new Set(val);
        
          var intersection = new Set(
            [...set1].filter(char => set2.has(char))
          );
        
          return intersection.size > 0;
        }
      }
    },
    {
      message: 'A number (0-9)',
      valid: false,
      regex: new RegExp('(?=.*[0-9])')
    }
  ];

  constructor(public data: DataService) {
    // Use consistent password rules for all users
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    for(let i in this.errors){
      this.errors[i].valid = this.errors[i].regex.test(changes.text.currentValue);
    }
  }

}
